module.exports = __webpack_public_path__ + "img/riceball.99b1bc0d.svg";